"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodcastShowCategoryTargetsResponseToJSON = exports.PodcastShowCategoryTargetsResponseFromJSONTyped = exports.PodcastShowCategoryTargetsResponseFromJSON = exports.instanceOfPodcastShowCategoryTargetsResponse = void 0;
var runtime_1 = require("../runtime");
var ShowCategories_1 = require("./ShowCategories");
/**
 * Check if a given object implements the PodcastShowCategoryTargetsResponse interface.
 */
function instanceOfPodcastShowCategoryTargetsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPodcastShowCategoryTargetsResponse = instanceOfPodcastShowCategoryTargetsResponse;
function PodcastShowCategoryTargetsResponseFromJSON(json) {
    return PodcastShowCategoryTargetsResponseFromJSONTyped(json, false);
}
exports.PodcastShowCategoryTargetsResponseFromJSON = PodcastShowCategoryTargetsResponseFromJSON;
function PodcastShowCategoryTargetsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'showCategories': !(0, runtime_1.exists)(json, 'show_categories') ? undefined : (json['show_categories'].map(ShowCategories_1.ShowCategoriesFromJSON)),
    };
}
exports.PodcastShowCategoryTargetsResponseFromJSONTyped = PodcastShowCategoryTargetsResponseFromJSONTyped;
function PodcastShowCategoryTargetsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'show_categories': value.showCategories === undefined ? undefined : (value.showCategories.map(ShowCategories_1.ShowCategoriesToJSON)),
    };
}
exports.PodcastShowCategoryTargetsResponseToJSON = PodcastShowCategoryTargetsResponseToJSON;
